import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('interazioni');
export const actions = helper.createActions('interazioni', actionTypes);